import React from 'react';
import PropTypes from 'prop-types';

import {
  useTable,
  useSortBy,
  usePagination,
  useRowSelect,
  useGlobalFilter
} from 'react-table';

import TableDropdown from './TableDropdown';

const WithdrawalsTableWrapper = ({
  children,
  columns,
  data,
  action,
  sortable,
  dropdown,
  dropdownColumnWidth,
  pagination,
  perPage = 10
}) => {
  const {
    getTableProps,
    headers,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    nextPage,
    previousPage,
    setPageSize,
    gotoPage,
    pageCount,
    state: { pageIndex, pageSize, selectedRowIds, globalFilter },
    setGlobalFilter
  } = useTable(
    {
      columns,
      data,
      disableSortBy: !sortable,
      initialState: {
        hiddenColumns: ['id'],
        pageSize: pagination ? perPage : data.length,
        sortBy: [
          {
            id: 'status',
            desc: true
          }
        ]
      }
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect,
    hooks => {
      if (dropdown) {
        hooks.visibleColumns.push(columns => [
          ...columns,
          {
            id: 'dropdown',
            headerProps: {
              style: {
                maxWidth: dropdownColumnWidth
              }
            },
            cellProps: {
              style: {
                maxWidth: dropdownColumnWidth
              }
            },
            Cell: ({ row }) => <TableDropdown row={row} action={action} />
          }
        ]);
      }
    }
  );

  const recursiveMap = children => {
    return React.Children.map(children, child => {
      if (child.props?.children) {
        return React.cloneElement(child, {
          children: recursiveMap(child.props.children)
        });
      } else {
        if (child.props?.table) {
          return React.cloneElement(child, {
            ...child.props,
            getTableProps,
            headers,
            page,
            prepareRow,
            canPreviousPage,
            canNextPage,
            nextPage,
            previousPage,
            gotoPage,
            pageCount,
            pageIndex,
            selectedRowIds,
            pageSize,
            setPageSize,
            globalFilter,
            setGlobalFilter
          });
        } else {
          return child;
        }
      }
    });
  };

  return <>{data.length ? recursiveMap(children) : 'No records found.'}</>;
};

WithdrawalsTableWrapper.propTypes = {
  children: PropTypes.any,
  columns: PropTypes.any,
  data: PropTypes.any,
  process: PropTypes.any,
  sortable: PropTypes.any,
  selection: PropTypes.any,
  selectionColumnWidth: PropTypes.any,
  dropdown: PropTypes.any,
  dropdownColumnWidth: PropTypes.any,
  pagination: PropTypes.any,
  perPage: PropTypes.any,
  row: PropTypes.any,
  action: PropTypes.any
};

export default WithdrawalsTableWrapper;
